import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { fmtDate } from "@/lib/formatters";

/** "Histórico Cirúrgico" tab — list of surgeries linked to the patient. */
export default function HistoricoCirurgicoTab({ cases }) {
  return (
    <Card className="border-slate-200 shadow-sm">
      <CardContent className="p-0 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 border-b border-slate-200 text-xs uppercase text-slate-600">
            <tr>
              <th className="text-left px-4 py-3">Código</th>
              <th className="text-left px-4 py-3">Data</th>
              <th className="text-left px-4 py-3">Procedimento</th>
              <th className="text-left px-4 py-3">Status</th>
              <th className="text-right px-4 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {cases.length === 0 && (
              <tr><td colSpan={5} className="text-center p-8 text-slate-400">Nenhuma cirurgia registrada.</td></tr>
            )}
            {cases.map((c) => (
              <tr key={c.id} className="border-b border-slate-100 hover:bg-slate-50">
                <td className="px-4 py-3 font-mono text-xs">{c.case_code}</td>
                <td className="px-4 py-3">{fmtDate(c.surgery_date)}</td>
                <td className="px-4 py-3 font-medium">{c.procedure_name}</td>
                <td className="px-4 py-3 text-slate-600">{c.status?.replace(/_/g, " ")}</td>
                <td className="px-4 py-3 text-right">
                  <Link to={`/casos/${c.id}`} className="text-blue-700 hover:underline text-sm">Abrir</Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </CardContent>
    </Card>
  );
}
